import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'blood_pressure_treatment'

const OPTIONS = [
  {
    value: 'no-normal',
    translationKey: 'pages.onboarding.bloodPressureTreatment.options.noNormal',
  },
  {
    value: 'yes-controlled',
    translationKey:
      'pages.onboarding.bloodPressureTreatment.options.yesControlled',
  },
  {
    value: 'yes-uncontrolled',
    translationKey:
      'pages.onboarding.bloodPressureTreatment.options.yesUncontrolled',
  },
  {
    value: 'not-sure',
    translationKey: 'pages.onboarding.bloodPressureTreatment.options.notSure',
  },
]

const answers: AnswerType[] = [
  {
    emoji: '✅',
    title: 'pages.onboarding.bloodPressureTreatment.options.noNormal',
    value: 'no-normal',
  },
  {
    emoji: '💊',
    title: 'pages.onboarding.bloodPressureTreatment.options.yesControlled',
    value: 'yes-controlled',
  },
  {
    emoji: '⚠️',
    title: 'pages.onboarding.bloodPressureTreatment.options.yesUncontrolled',
    value: 'yes-uncontrolled',
  },
  {
    emoji: '❓',
    title: 'pages.onboarding.bloodPressureTreatment.options.notSure',
    value: 'not-sure',
  },
]

export default function BloodPressureTreatmentPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Are you currently treated for high blood pressure?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.bloodPressureTreatment.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
